import {toast, ToastContainer} from "react-toastify";
import React from "react";
import IconError from "../components/icon/IconError";
import IconDone from "../components/icon/IconDone";

export default function ToastNotification() {
  return (
    <ToastContainer toastClassName='rounded-md text-sm py-2.5 px-4' draggable={false}/>
  )
}

export function showInfo(msg) {
  toast.success(<><IconDone type='white'/>  {msg}</>, {
    position: toast.POSITION.BOTTOM_CENTER,
    hideProgressBar: true
  });
}

export function showError(msg) {
  toast.error(<><IconError type='white'/>  {msg}</>, {
    position: toast.POSITION.BOTTOM_CENTER,
    hideProgressBar: true
  });
}
